import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";

import api from "../../service/api";

import MessageForLargeDevices from "../../components/MessageForLargeDevices";
import MessageForSmallDevices from "../../components/MessageForSmallDevices";

const Messages = () => {
    const [windowWidth, setWindowWidth] = useState<number>(1024);
    const [conversations, setConversations] = useState([]);

    const websocket = useSelector((state: {websocket: any}) => state.websocket);

    useEffect(() => {
        const width = window.screen.width;
        
        setWindowWidth(width);
    }, []);

    useEffect(() => {
        const getConversationsAtApi = async () => {
            const { data } = await api.get("chat/title/list");
            
            setConversations(data.chatTitle);
        }

        if(websocket.socket !== null){
            websocket.socket.on("newMessage", () => {
                getConversationsAtApi();
            });
        }

        getConversationsAtApi();
    }, []);

    return(
        <>
            {
                windowWidth <= 768 ?
                <MessageForSmallDevices 
                    conversations={conversations}
                /> :
                <MessageForLargeDevices
                    conversations={conversations}
                />
                
            }
        </>
    )
}

export default Messages;